import React from "react";
import {observer} from "mobx-react-lite";
import ListView from "../components/list /ListView";
import {ListViewState} from "../components/list /ListViewState";
import {BrandSelectState} from "../components/elements/brand/BrandSelectState";
import {BrandStore} from "../components/elements/brand/BrandStore";
import {useMatch} from "react-location";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";

const Home = observer(() => {
    const {data} = useMatch().data;
    const {products, brandsList, initialBrand} = data
    const listViewState = ListViewState.create({
        brandSelectState: BrandSelectState.create({brandStore: BrandStore.create()})
    })

    const {brandSelectState} = listViewState
    const {brandStore} = brandSelectState
    brandSelectState.setConsumer(listViewState.setBrandSelected)

    brandStore.setBrandList(brandsList) //set brands
    initialBrand && brandSelectState.select(initialBrand?.id) //set initial brand
    !initialBrand && brandSelectState.select("all") //set initial brand to all if no initial brand
    initialBrand && listViewState.fetchBrandImage()
    products && listViewState.setListItems(products) //set products list
    return (
        <>
            <Header />
            <ListView store={listViewState}/>
            <Footer/>
        </>
    )
})


export default Home;
